import React from 'react';
import {Col, Container, Row} from "react-bootstrap";

function Whychoose(props) {
    return (
        <section className=" tekrevol_dark_bg  p-100">
            <Container>
                <Row>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <div className="example" data-text="Services">
                            <h2>Providing Java Software Development Services For Robust Applications</h2>
                        </div>
                    </Col>
                    <Col xs={12} md={6} lg={6} xl={6} xxl={6}>
                        <p>TekRevol is a java software development company who knows that developing a solution is essential, but what is more important is the delivery of excellence and long-term value. Our expert Java developers for hire know how to build excellent mobility solutions for our clients and help them achieve their business objectives. From small to large – we assist businesses of all sizes to accomplish and grow sustainably.</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Whychoose;